import { useRef } from "react";

// Define props type
interface DynamicIframeProps {
  src: string; // required
  title?: string; // optional
}

function DynamicIframe({ src, title }: DynamicIframeProps) {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const handleLoad = () => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const doc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!doc) return;

    iframe.style.height = doc.body.scrollHeight + "px";

    // Inject CSS inside the iframe
    const style = doc.createElement("style");
    style.innerHTML = `
      section.block.form-block {
        background: transparent !important;
        padding: 0 !important;
      }
    `;
    doc.head.appendChild(style);
  };

  return (
    <iframe
      title={title ?? "Dynamic Iframe"} // fallback if title is not provided
      ref={iframeRef}
      src={src}
      className="w-full border-0 overflow-hidden rounded-sm"
      scrolling="no"
      onLoad={handleLoad}
    />
  );
}

export default DynamicIframe;
